// Types + pure helpers for the Agent tab. Shapes mirror
// ghostfit-console/lib/agent-tasks.js (server).

export const AGENT_TASK_STATES = ['received', 'classified', 'acting', 'verifying', 'done', 'escalated', 'failed'] as const;
export type AgentTaskState = (typeof AGENT_TASK_STATES)[number];

export type TaskCheck = { id: string; passed: boolean; detail?: string };
export type TaskStep = { at: string; tool: string; target: string; status: number; ms: number; summary: string };
export type AgentTask = {
  id: string;
  taskId: string;
  source?: { kind: string };
  actor?: string;
  category?: string;
  entities?: { submissionIds?: string[]; storeIds?: string[] };
  state: string;
  steps?: TaskStep[];
  checks?: TaskCheck[];
  outcome?: { failureReason?: string };
  createdAt: string;
  updatedAt?: string;
};
export type AgentTasksPayload = { tasks: AgentTask[]; count: number };

export function agentTasksUrl(state?: string): string {
  return state ? `/api/agent-tasks?limit=100&state=${encodeURIComponent(state)}` : '/api/agent-tasks?limit=100';
}

export function stateTone(state: string): 'ok' | 'bad' | 'warn' | 'neutral' {
  if (state === 'done') return 'ok';
  if (state === 'failed') return 'bad';
  if (state === 'escalated') return 'warn';
  return 'neutral';
}

export function checksSummary(checks?: TaskCheck[]): string {
  if (!checks || checks.length === 0) return '—';
  return `${checks.filter((c) => c.passed).length}/${checks.length}`;
}
